import React from 'react'
import Manager from '../../public/components/Manager'
import MethodApplyDetail from './MethodApplyDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '申请编号', field: 'Number', minWidth: 150, search: true, },
        { _text: '拟开展新项目说明', field: 'Explain', minWidth: 250, flex: 10, search: true },
        { _text: '原因说明', field: 'ReasonExplain', minWidth: 250, flex: 10, search: true },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
        { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <MethodApplyDetail {...props} id={data.id} />)
    }
}

export default props => <Manager {...props} config={config} />